export default __webpack_public_path__ + "static/media/logo2.82e9da1f.png";